export const CustomEventTypes = {
  SelectedInstanceChanged: 'Visualization/SelectedInstanceChanged',
};

export const PI_HALF = Math.PI * 0.5;
export const QUARTER_THRESHOLD = PI_HALF * 0.1;
